exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AccountStatus_component_3Ctt { width: 100%; }\n", ""]);

// exports
exports.locals = {
	"component": "AccountStatus_component_3Ctt"
};